import { SubParticipantPosition } from '@collector/sportsapi-client-legacy'
import { SubParticipant } from '@collector/sportsapi-types'

/**
 * Player is subParticipant which can be attached with meaningful event data (position in formation, incidents player/assistant)
 */
export type IsPlayer = (subParticipant: SubParticipant) => boolean

/**
 * If position is priority, it should be shown in the top of the list
 */
export type IsPriorityPosition = (
  subParticipantPosition: SubParticipantPosition,
) => boolean

export type PlayersConfig = {
  isPlayer?: IsPlayer
  isPriorityPosition?: IsPriorityPosition
  compareFn?: (a: SubParticipant, b: SubParticipant) => number
}

export function sortSubParticipants(
  subParticipants: SubParticipant[],
  isPriorityPosition: IsPriorityPosition | undefined,
): SubParticipant[] {
  return [...subParticipants].sort((a, b) => {
    // Rule 1: priority position on top
    if (isPriorityPosition) {
      if (isPriorityPosition(a.position) && !isPriorityPosition(b.position)) {
        return -1
      }

      if (!isPriorityPosition(a.position) && isPriorityPosition(b.position)) {
        return 1
      }
    }

    // Rule 2: non-empty shirt_nr in ascending order
    if (a.shirt_nr && b.shirt_nr) {
      const shirtNrA = +a.shirt_nr
      const shirtNrB = +b.shirt_nr

      if (shirtNrA > shirtNrB) {
        return 1
      }

      if (shirtNrA < shirtNrB) {
        return -1
      }

      return a.short_name.localeCompare(b.short_name)
    }

    // Rule 3: empty shirt_nr at the bottom
    if (a.shirt_nr && !b.shirt_nr) return -1
    if (!a.shirt_nr && b.shirt_nr) return 1

    // otherwise, maintain original order
    return 0
  })
}
